import { EColumnType } from "../types/Column.js";
const normalizeValue = (value) => {
  if (typeof value === "boolean") {
    return String(value);
  }
  if (typeof value === "number") {
    return value;
  }
  const numericValue = Number(value);
  if (isNaN(numericValue)) {
    return value;
  }
  return numericValue;
};
const getValueFromOptions = (value, column) => {
  var _a;
  if (Array.isArray(column == null ? void 0 : column.options)) {
    const option = (_a = column == null ? void 0 : column.options) == null ? void 0 : _a.find((opt) => {
      const normalizedValue = normalizeValue(value);
      const normalizedOption = normalizeValue(opt.value);
      const normalizedLabel = normalizeValue(opt.label);
      return normalizedValue === normalizedOption || normalizedValue === normalizedLabel;
    });
    return (option == null ? void 0 : option.value) ?? value;
  }
  return void 0;
};
const getEditedValue = (value, column) => {
  if ((column == null ? void 0 : column.type) === EColumnType.enum) {
    return handleEnumType(value, column);
  }
  if ((column == null ? void 0 : column.type) === EColumnType.boolean) {
    return handleBooleanType(value, column);
  }
  if ((column == null ? void 0 : column.type) === EColumnType.enumList || (column == null ? void 0 : column.type) === EColumnType.stringList) {
    return handleListTypes(value, column);
  }
  return value;
};
const handleEnumType = (value, column) => {
  var _a;
  if (Array.isArray(value)) {
    return ((_a = value[0]) == null ? void 0 : _a.value) ?? null;
  }
  if (Array.isArray(column == null ? void 0 : column.options)) {
    return getValueFromOptions(value, column);
  }
};
const handleBooleanType = (value, column) => {
  if (Array.isArray(column == null ? void 0 : column.options) && (column == null ? void 0 : column.options.length)) {
    return getValueFromOptions(value, column);
  }
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
};
const handleListTypes = (value, column) => {
  return Array.isArray(value) ? value.map((v) => processValueForListTypes(v, column)) : processValueForListTypes(value, column);
};
const getCellValueIsEmpty = (value) => {
  return value === null || value === void 0 || value === "";
};
const processValueForListTypes = (v, column) => {
  const optionsArray = Array.isArray(column == null ? void 0 : column.options);
  const item = typeof v === "object" && v !== null ? v.value : v;
  return optionsArray ? getValueFromOptions(item, column) : item;
};
const DIFF_MESSAGES_LENGTH = 3;
const EDITOR_ID = "editorContainer";
const HEADER_MENU_STATE_ATTRIBUTE = "data-headermenustate";
export {
  DIFF_MESSAGES_LENGTH,
  EDITOR_ID,
  HEADER_MENU_STATE_ATTRIBUTE,
  getCellValueIsEmpty,
  getEditedValue
};
